/* src/app/template/template.component.scss */
a:hover {
  cursor: pointer;
}
a:not([href]):not([tabeindex]) {
  text-decoration: underline;
}
.mat-mdc-cell {
  text-align: left;
  align-self: center;
}
.mat-column-code {
  max-width: 100px;
}
.mat-column-content {
  max-width: 100px;
}
.edit-content-btn {
  cursor: pointer;
}
.column-icon {
  font-size: 16px;
  height: 16px;
  width: 16px;
  color: #777;
}
.mat-mdc-row:hover {
  background-color: darkgray;
  color: black;
}
.mat-mdc-row {
  border-color: #605959;
}
.menu {
  display: flex;
  padding-top: 20px;
}
.menu input {
  line-height: 2rem;
}
/*# sourceMappingURL=template.component.css.map */
